import type { ReactNode } from 'react';

export const symbol_warning_off: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M462.5-245.5Q454-254 454-267t8.5-21.5Q471-297 484-297t21.5 8.5Q514-280 514-267t-8.5 21.5Q497-237 484-237t-21.5-8.5ZM454-378v-128l60 60v68q0 13-8.5 21.5T484-348q-13 0-21.5-8.5T454-378Zm40.5-468.5Q501-843 506-835l293 507q8 13 3.5 24T788-288q-10 5-21.5 4T747-299L480-760l-52 90q-8 13-19.5 14t-21.5-4q-10-5-14.5-16t3.5-24l78-135q5-8 11.5-11.5T480-850q8 0 14.5 3.5ZM144-180h550L346-528 144-180ZM816-59l-62-61H92q-17 0-26-15t0-30l236-407L58-816q-9-9-8.5-21.5T59-859q9-9 21.5-9t21.5 9l757 758q9 9 9 21t-9 21q-9 9-21.5 9T816-59ZM520-354Zm58-113Z"
		/>
	</svg>
);
